
































import { Member, MemberFilterSettings } from '@/model/member.model';
import { Component, Emit, Prop, Provide, Vue, Watch } from 'vue-property-decorator';

export interface Filter {
  type: string;
  value: string | number;
}

@Component
export default class MembersFilters extends Vue {

  @Prop() hasNew: boolean = false

  @Provide() search: string = ''
  @Provide() filters: MemberFilterSettings = {}

  get years(): number[] {
    return this.$store.state.members.reduce((acc: number[], member: Member) => {
      const year = new Date(member.birth).getFullYear()
      return acc.includes(year) ? acc : [...acc, year];
    }, []).sort()
  }

  filterByYear(year: string) {
    let values = this.filters['year'] || [];

    if (values.includes(year)) {
      values = values.filter((v: any) => v !== year)
    } else {
      values = [year];
    }

    this.filters = { ...this.filters, ['year']: values };

    this.update();
  }

  filterByStatus() {
    let update = { ...this.filters };

    if (update.status) {
      delete update.status;
    } else {
      update = { ...this.filters, ['status']: [1] };
    }

    this.filters = { ...update };

    this.update();
  }

  @Watch('search')
  onSearch(val: string) {
    this.filters = { ...this.filters, ['search']: [this.search] }
    this.update();
  }

  @Emit('filtersChanged')
  update(): MemberFilterSettings {
    return this.filters;
  }
}

